/* ==========================================================================
   MerryLit — custom product page behaviour
   Self-contained, idempotent (safe if loaded by several sections),
   and re-initialises on Shopify theme-editor section reloads.
   ========================================================================== */
(function () {
  if (window.__LCPP__) { window.__LCPP__.init(); return; }

  function ready(el, key) {
    if (el.getAttribute(key) === '1') return false;
    el.setAttribute(key, '1');
    return true;
  }

  /* Shared map: option value / variant title (lowercased) -> media id */
  var LC_MEDIA = {};

  function lcSwapImage(mediaId) {
    if (mediaId == null) return;
    var thumb = document.querySelector('[data-lc-thumb][data-lc-media-id="' + mediaId + '"]');
    if (thumb) { thumb.click(); return true; }
    return false;
  }

  function lcLookupMedia(str) {
    if (str == null) return null;
    var k = String(str).trim().toLowerCase();
    return Object.prototype.hasOwnProperty.call(LC_MEDIA, k) ? LC_MEDIA[k] : null;
  }

  /* ---------- Quantity steppers ---------- */
  function initQty(root) {
    root.querySelectorAll('[data-lc-qty]').forEach(function (w) {
      if (!ready(w, 'data-lc-qr')) return;
      var input = w.querySelector('[data-lc-qty-input]');
      w.querySelector('[data-lc-qty-minus]').addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      w.querySelector('[data-lc-qty-plus]').addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });
  }

  /* ---------- Accordions (FAQ + mini) ---------- */
  function initAccordion(root) {
    root.querySelectorAll('[data-lc-accordion]').forEach(function (acc) {
      if (!ready(acc, 'data-lc-ar')) return;
      acc.querySelectorAll('[data-lc-acc-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var panel = btn.parentElement.querySelector('[data-lc-acc-panel]');
          var open = btn.getAttribute('aria-expanded') === 'true';
          acc.querySelectorAll('[data-lc-acc-toggle]').forEach(function (b) {
            b.setAttribute('aria-expanded', 'false');
            var p = b.parentElement.querySelector('[data-lc-acc-panel]');
            if (p) p.style.maxHeight = '0px';
          });
          if (!open && panel) {
            btn.setAttribute('aria-expanded', 'true');
            panel.style.maxHeight = panel.scrollHeight + 40 + 'px';
          }
        });
      });
    });
  }

  /* ---------- Inline review carousel ---------- */
  function initCarousel(root) {
    root.querySelectorAll('[data-lc-carousel]').forEach(function (car) {
      if (!ready(car, 'data-lc-cr')) return;
      var slides = car.querySelectorAll('[data-lc-slide]');
      var dots = car.querySelectorAll('[data-lc-dot]');
      if (slides.length < 2) return;
      var idx = 0, timer;
      function show(i) {
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });
      }
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          show(parseInt(d.getAttribute('data-lc-index'), 10));
          restart();
        });
      });
      function restart() { clearInterval(timer); timer = setInterval(function () { show(idx + 1); }, 4500); }
      restart();
    });
  }

  /* ---------- Countdown timer ---------- */
  function initCountdown(root) {
    root.querySelectorAll('[data-lc-countdown]').forEach(function (el) {
      if (!ready(el, 'data-lc-cdr')) return;
      var deadlineStr = (el.getAttribute('data-lc-deadline') || '').trim();
      var target;
      if (deadlineStr) {
        target = new Date(deadlineStr.replace(' ', 'T')).getTime();
        if (isNaN(target)) target = null;
      }
      if (!target) {
        var hours = parseFloat(el.getAttribute('data-lc-fallback')) || 4;
        target = Date.now() + hours * 3600 * 1000;
      }
      function pad(n) { return String(n).padStart(2, '0'); }
      function tick() {
        var diff = Math.max(0, Math.floor((target - Date.now()) / 1000));
        var h = Math.floor(diff / 3600), m = Math.floor((diff % 3600) / 60), s = diff % 60;
        el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
        if (diff <= 0) clearInterval(el._lcTimer);
      }
      tick();
      el._lcTimer = setInterval(tick, 1000);
    });
  }

  /* ---------- Gallery thumbnails ---------- */
  function initGallery(root) {
    root.querySelectorAll('[data-lc-gallery]').forEach(function (g) {
      if (!ready(g, 'data-lc-gr')) return;
      var main = g.querySelector('[data-lc-main-image]');
      g.querySelectorAll('[data-lc-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          var full = t.getAttribute('data-lc-full');
          if (full && main) { main.src = full; main.removeAttribute('srcset'); }
          g.querySelectorAll('[data-lc-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
    });
  }

  /* ---------- Variant picker (real product data) ---------- */
  function initVariants(root) {
    root.querySelectorAll('[data-lc-product-section]').forEach(function (sec) {
      if (!ready(sec, 'data-lc-vr')) return;
      var dataEl = sec.querySelector('[data-lc-variant-json]');
      var mapEl = sec.querySelector('[data-lc-price-map]');
      var optionsWrap = sec.querySelector('[data-lc-options]');
      if (!dataEl) return;
      var variants, priceMap = {};
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      try { priceMap = JSON.parse(mapEl.textContent); } catch (e) {}

      variants.forEach(function (v) {
        var info = priceMap[v.id] || {};
        var mid = info.media_id;
        if (mid == null) return;
        function add(x) { if (x != null && String(x).trim() !== '') LC_MEDIA[String(x).trim().toLowerCase()] = mid; }
        add(v.option1);
        add(v.title);
        if (v.options && v.options[0]) add(v.options[0]);
      });

      var hiddenId = sec.querySelector('[data-lc-variant-id]');
      var priceEl = sec.querySelector('[data-lc-price]');
      var compareEl = sec.querySelector('[data-lc-compare]');
      var saveEl = sec.querySelector('[data-lc-save]');
      var atc = sec.querySelector('[data-lc-atc]');
      var atcText = sec.querySelector('[data-lc-atc-text]');
      var gallery = sec.querySelector('[data-lc-gallery]');

      function selectedValues() {
        if (!optionsWrap) return [];
        var groups = optionsWrap.querySelectorAll('.lc-opt');
        var vals = [];
        groups.forEach(function (grp, i) {
          var sel = grp.querySelector('.is-selected');
          vals[i] = sel ? sel.getAttribute('data-lc-value') : null;
        });
        return vals;
      }

      function findVariant(vals) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === vals[i]; });
        });
      }

      function apply(v) {
        if (!v) return;
        if (hiddenId) hiddenId.value = v.id;
        var info = priceMap[v.id] || {};
        if (priceEl && info.price) priceEl.textContent = info.price;
        if (compareEl) {
          if (info.compare_raw && info.compare_raw > info.price_raw) {
            compareEl.textContent = info.compare;
            compareEl.hidden = false;
            if (saveEl) {
              var pct = Math.round((info.compare_raw - info.price_raw) / info.compare_raw * 100);
              saveEl.textContent = '🏷 SAVE ' + pct + '%';
              saveEl.hidden = false;
            }
          } else {
            compareEl.hidden = true;
            if (saveEl) saveEl.hidden = true;
          }
        }
        if (atc) {
          if (v.available) {
            atc.disabled = false;
            if (atcText) atcText.textContent = atc.getAttribute('data-lc-add-label') || 'ADD TO CART';
          } else {
            atc.disabled = true;
            if (atcText) atcText.textContent = atc.getAttribute('data-lc-soldout-label') || 'SOLD OUT';
          }
        }
        if (gallery && info.media_id != null) {
          var thumb = gallery.querySelector('[data-lc-media-id="' + info.media_id + '"]');
          if (thumb) thumb.click();
        }
      }

      if (optionsWrap) {
        optionsWrap.querySelectorAll('.lc-pill, .lc-swatch').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var grp = btn.closest('.lc-opt');
            grp.querySelectorAll('.lc-pill, .lc-swatch').forEach(function (b) { b.classList.remove('is-selected'); });
            btn.classList.add('is-selected');
            var labelEl = grp.querySelector('.lc-opt__sel');
            if (labelEl) labelEl.textContent = btn.getAttribute('data-lc-value');
            apply(findVariant(selectedValues()));
          });
        });
      }
    });
  }

  var LC_BUNDLE_BOUND = false;
  function initBundleSync() {
    if (LC_BUNDLE_BOUND) return;
    LC_BUNDLE_BOUND = true;
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.tagName !== 'SELECT') return;
      var mid = lcLookupMedia(t.value);
      if (mid == null && t.options && t.selectedIndex > -1) {
        var opt = t.options[t.selectedIndex];
        if (opt) mid = lcLookupMedia(opt.textContent);
      }
      if (mid != null) lcSwapImage(mid);
    }, true);
  }

  function init() {
    var root = document;
    initQty(root);
    initAccordion(root);
    initCarousel(root);
    initCountdown(root);
    initGallery(root);
    initVariants(root);
    initBundleSync();
  }

  window.__LCPP__ = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
